import React from "react"
import LoadingComponent from "./LoadingComponent"

export function ProgressHUD({ msg }) {
  return (
    <div>
      <div className="spinnerTransparentContainer">
        <div className="spinnerTextBlack">
          <LoadingComponent />
          <br />
          {msg ? msg : "Loading..."}
        </div>
      </div>
    </div>
  )
}
